import React, { useContext } from "react";
import { Box, Button, InputAdornment, useTheme } from "@material-ui/core";
import { Label, Question, Section } from "../../form-layout";
import { ReactEasyForm, TextField } from "@aeco-cloud/react-easy-form";
import { useForm, UseFormMethods } from "react-hook-form";
import settings from "../../../styles/settings";
import { TextContext } from "@pages/bereken-bijdrage";

type FormProps = {
  onSubmit: any;
  form: UseFormMethods;
};

const Form = (props: FormProps) => {
  const theme = useTheme();
  const form = useForm();
  const text = useContext(TextContext);
  return (
    <ReactEasyForm
      form={form}
      style={{
        width: "100%",
        maxWidth: "430px",
      }}
      errorStyle={{ color: theme.palette.error.main, margin: "10px 0px" }}
    >
      <Section
        elevation={0}
        elevationOnFocus={0}
        style={{ backgroundColor: "transparent" }}
        spacing={1}
      >
        <Question>
          <Label label={text.input1_label} tooltip={text.input1_tooltip} />
          <TextField
            name="ZIB_revenue"
            rules={{
              required: text.questionRequired,
              validate: {
                greaterThanZero: (value: any) => parseInt(value) >= 0 || text.greaterThanZero,
              },
            }}
            muiTextFieldProps={{
              ...settings.muiTextFieldProps,
              InputProps: {
                startAdornment: <InputAdornment position="start">€</InputAdornment>,
                margin: "dense",
              },
            }}
          />
        </Question>
        <Question>
          <Label label={text.input2_label} tooltip={text.input2_tooltip} />
          <TextField
            name="ZIB_cost"
            rules={{
              validate: {
                greaterThanZero: (value: any) => parseInt(value) >= 0 || text.greaterThanZero,
                check: () => {
                  return (
                    Number(form.getValues("ZIB_cost")) <= Number(form.getValues("ZIB_revenue")) ||
                    text.costsNotGreaterThanIncome
                  );
                },
              },
            }}
            muiTextFieldProps={{
              ...settings.muiTextFieldProps,
              InputProps: {
                startAdornment: <InputAdornment position="start">€</InputAdornment>,
                margin: "dense",
              },
            }}
          />
        </Question>
      </Section>

      <Box padding="35px" width="100%" maxWidth="300px" marginLeft="auto" marginRight="auto">
        <Button
          onClick={form.handleSubmit(props.onSubmit)}
          tabIndex={2}
          variant="contained"
          color="secondary"
          fullWidth={true}
        >
          {text.calculate}
        </Button>
      </Box>
    </ReactEasyForm>
  );
};

export default Form;
